import store from "@/store/index.js";
let getModule = {
  //获取用户相关的数据
  async getUser(value = false) {
    //token是否一致
    store.dispatch("cookies/setAccessToken");
  },
};
export const UserModule = getModule;
